module.exports = __webpack_public_path__ + "static/media/logo2.b233a83e.png";